import { ReportScheduleType } from '@type/report-schedule-type';

export class ModulePathConstant {

    //paynow module
    static TEMPLATE_CENTER_MODULE='TEMPLATE_CENTER_MODULE';
    static ONEPAGE_TEMPLATE='ONEPAGE_TEMPLATE';
    static ONEPAGE_TEMPLATE_CONFIG='ONEPAGE_TEMPLATE_CONFIG';
    static ORDER_MODULE='ORDER_MODULE';
    static ORDER='ORDER';
    static ORDER_REPORT='ORDER_REPORT';
    static PRODUCT_CENTER_MODULE='PRODUCT_CENTER';
    static PRODUCT_MODULE='PRODUCT';
    static ONEPAGE_TEMPLATE_DEPLOYMENT='ONEPAGE_TEMPLATE_DEPLOYMENT';
    static HTML_TEMPLATE='HTML_TEMPLATE';
    
    
    //moduleName
    static HOME_MODULE='HOME';
    static USER_MODULE='USER';
    static SYSTEM_USER_MODULE='SYSTEM_USER';
    static MERCHANT_USER_MODULE='MERCHANT_USER';
    static MERCHANT_SETTINGS_MODULE='MERCHANT_SETTINGS';
    static GROUP_MODULE='GROUP';
    static ROLE_MODULE='ROLE';
    static SYSTEM_MODULE='SYSTEM_MODULE';
    static SETTING_MODULE='SETTING';
    static QRCODE_GENERATE_MODULE = "QRCODE_GENERATOR";

    static CREATE_TASK_MODULE='CREATE_TASK';
    static RECEIPT_MODULE='RECEIPT';
    static QUERY_DONE_TASK_MODULE='QUERY_DONE_TASK';
    static USER_TASK_MODULE='USER_TASK';
    static DOC_UPLOAD_MODULE='DOC_UPLOAD';
    static EMAIL_TEMPLATE_MODULE='EMAIL_TEMPLATE';

    static CUSTOMER_CENTER_MODULE='CUSTOMER_CENTER';
    static COMPANY_MODULE='COMPANY';
    static COMPANY_RECEIPT_MODULE='COMPANY_RECEIPT';


    //paynow path
    static HTML_TEMPLATE_PATH='/html-template';
    static ONEPAGE_TEMPLATE_PATH='/onepage-template';
    static ONEPAGE_TEMPLATE_CONFIG_PATH='/onepage-template-config';
    static ORDER_PATH='/order';
    static ORDER_REPORT_PATH = '/order-report';
    static ONEPAGE_TEMPLATE_DEPLOYMENT_PATH='/deployment';

    //path
    static HOME_PATH = '/home';
    static PRODUCT_PATH = '/product-form';
    static WORKFLOW_FORM_PATH = '/workflow-form';
    static TASK_FORM_PATH = '/task-form';
    static USER_TASK_PATH = '/user-task';

    static QUERY_MY_START_TASK_PATH = '/query-my-start-task';
    static QUERY_TO_DO_TASK_PATH = '/query-to-do-task';
    static RECEIPT_PATH = '/receipt';
    
    static USER_PATH = '/user';
    static MERCHANT_USER_PATH = '/merchant-user';
    static MERCHANT_SETTINGS_PATH = '/merchant-settings';
    static ROLE_PATH = '/role';
    static GROUP_PATH = '/group';
    static SETTING_PATH = '/systemparameter';
    static SETTING_SETUP = '/systemparameter';

    static QRCODE_GENERATOR_PATH = '/generator';

    static DOC_UPLOAD_PATH = '/doc-upload';
    static COMPANY_PATH = '/company';
}


